export default "__VITE_ASSET__1c2476b5__"